function Two(){
    return(
        <div class="gal">
        <div class="gal_1">
            <img src="/images/ten.jpg" alt="Dragon Ball"></img>
            <h2>Goku's UI</h2>
            <p>In the Tournamnet of Power,Goku gets up even after blown down by Jiren for his Universe</p>
            <button>Action</button>
        </div>
        <div class="gal_1">
            <img src="/images/six.jpg" alt="Naruto"></img>
            <h2>Naruto's Childhood</h2>
            <p>As the Nine Tails was sealed inside him, he grew up with a lonely and difficult childhood</p>
            <button>Emotion</button>
        </div>

        <div class="gal_1">
            <img src="/images/gojo.jpg" alt="JJK"></img>
            <h2>Gojo's Return</h2>
            <p>Gojo returns to the battle after being defeated by the assasin Toji</p>
            <button>Action/Emotion</button>

        </div>

        <div class="gal_1">
            <img src="/images/eight.jpg" alt="Solo Levelling"></img>
            <h2>Igris-Knight Commander</h2>
            <p>After defeating the Kinght Commander Igris, Sung arise him to be his Shadow Commander</p>
            <button>Aura</button>
        </div>

    </div>
    )
}
export default Two;
